module.exports = __webpack_public_path__ + "img/01.d7e4d00e.jpg";